<template>
  <div class="wrapper">
    <dashboard-bar refreshButton />
    <div class="body">
      <div class="row">
        <div class="col-12">
          <span class="header-icon">
            <font-awesome-icon :icon="['fas', 'edit']" />
          </span>
          <h2>{{ $t('manualAnswer.pageTitle') }}</h2>
        </div>
      </div>
      <div class="row col-12 mt-4">
        <input
          type="text"
          class="form-control col-3"
          @keyup="handleFilter"
          v-model="filter"
          :placeholder="$t('manualAnswer.searchInput')"
        />
        <button @click="cleanFilter" class="btn btn-outline-primary">
          {{ $t('manualAnswer.searchButton') }}
        </button>
      </div>
      <div class="row">
        <div class="col-12">
          <b-table
            striped
            id="manual-table"
            class="mt-4"
            :items="myInvites.customers"
            :fields="fields"
            :busy="loading"
          >
            <template v-slot:table-busy>
              <div class="text-center text-primary my-2">
                <b-spinner type="grow" class="align-middle"></b-spinner>
              </div>
            </template>
            <!-- Ação -->
            <template v-slot:cell(action)="row">
              <span>{{ row.item.actionId.name }}</span> <br />
              <span class="user-info">
                {{ $t('manualAnswer.metric') }}:
                {{ getMetricLabel(row.item.actionId.type) }}
              </span>
            </template>
            <!-- Cliente -->
            <template v-slot:cell(costumer)="row">
              <span class="user-info">
                {{ checkName(row.item.anonymousResponse, row.item.name) }}
              </span>
              <br />
              <span class="user-info">
                {{ $t('manualAnswer.email') }} :
                {{
                  checkUserData(
                    row.item.email,
                    userProfile.permissions.manual.anonymous_profile,
                  )
                }}
              </span>
              <br />
              <span class="user-info">
                {{ $t('manualAnswer.phone') }} :
                {{
                  checkUserData(
                    row.item.phone,
                    userProfile.permissions.manual.anonymous_profile,
                  )
                }}
              </span>
              <br />
            </template>
            <!-- Data -->
            <template v-slot:cell(createdAt)="row">
              {{ dateFormat(new Date(row.item.createdAt)) }}
            </template>
            <!-- Lembrete -->
            <template v-slot:cell(reminder)="row">
              <span v-if="row.item.reminderDates.length > 0">
                {{
                  dateFormat(
                    new Date(
                      row.item.reminderDates[row.item.reminderDates.length - 1],
                    ),
                  )
                }}
              </span>
              <span v-else>
                -
              </span>
            </template>
            <!-- Dias -->
            <template v-slot:cell(days)="row">
              {{ setDifferenceInDays(new Date(row.item.createdAt)) }}
            </template>
            <!-- Canal -->
            <template v-slot:cell(channel)="row">
              {{
                row.item.actionId.channel === 'emailsms'
                  ? $t('manualAnswer.both')
                  : row.item.actionId.channel
              }}
            </template>
            <!-- Status -->
            <template v-slot:cell(active)="row">
              <div v-if="row.item.active">
                <b-badge variant="primary" style="color: #fff;">
                  {{ $t('manualAnswer.active') }}
                </b-badge>
              </div>
              <div v-else>
                <b-badge variant="secondary" style="color: #fff;">
                  {{ $t('manualAnswer.expired') }}
                </b-badge>
                <font-awesome-icon
                  :title="`${$t('manualAnswer.updateInvite')}`"
                  @click="refreshToken(row.item._id)"
                  class="refresh-token"
                  :icon="['fas', 'sync-alt']"
                />
              </div>
            </template>
            <!-- Resposta Manual -->
            <template
              v-slot:cell(options)="row"
              v-if="userProfile.permissions.manual.submit"
            >
              <div class="table-icons">
                <a
                  @click="openModal(row.item.researchToken, row.index)"
                  v-b-modal="`manual-answer`"
                >
                  <font-awesome-icon :icon="['fas', 'edit']" />
                </a>
              </div>
            </template>
          </b-table>
          <div v-show="!loading" class="pagination-area-manual-answers">
            <paginate
              v-model="page"
              :pageCount="myInvites.paginate || 1"
              :clickHandler="updateTable"
              :prevText="'‹'"
              :nextText="'›'"
              :activeClass="'active'"
              :containerClass="'pagination b-pagination'"
              :pageClass="'page-item'"
            >
            </paginate>
          </div>
          <modal-manual-answer :position="rowIndex" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import { format } from 'date-fns';
import pt from 'date-fns/locale/pt';
import Paginate from 'vuejs-paginate';
import swal from 'sweetalert';
import api from '@/services/api';
import ModalManualAnswer from '@/components/molecules/modal-manual-answer';
import dashboardBar from '@/components/molecules/dashboard-bar';
import EventBus from '../../../eventBus';

export default {
  components: {
    ModalManualAnswer,
    Paginate,
    dashboardBar,
  },

  data: () => ({
    myInvites: {
      customers: [],
      paginate: 0,
    },
    typingTimer: null,
    filter: null,
    userAuth: null,
    rowIndex: null,
    loading: true,
    dates: {
      start: null,
      end: new Date(),
    },
    fields: [],
    page: 1,
  }),

  computed: {
    ...mapState('invites', ['actionInfo']),
    ...mapState('companies', ['myMetric']),
    ...mapState('actions', ['myActionId', 'myActionName', 'actionGroupData', 'myActionsIds']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('authentication', ['userProfile']),
    ...mapFields('invites', ['loadingModal', 'error']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    EventBus.$on('update-table', (value) => {
      if (value) {
        this.updateTable(1);
      }
    });

    this.fields = [
      {
        key: 'controlId',
        label: this.$t('manualAnswer.invitesTable.labels.id'),
      },
      {
        key: 'action',
        label: this.$t('manualAnswer.invitesTable.labels.action'),
      },
      {
        key: 'costumer',
        label: this.$t('manualAnswer.invitesTable.labels.client'),
      },
      {
        key: 'createdAt',
        label: this.$t('manualAnswer.invitesTable.labels.submit'),
      },
      {
        key: 'reminder',
        label: this.$t('manualAnswer.invitesTable.labels.reminder'),
      },
      { key: 'days', label: this.$t('manualAnswer.invitesTable.labels.days') },
      {
        key: 'channel',
        label: this.$t('manualAnswer.invitesTable.labels.channel'),
      },
      {
        key: 'active',
        label: this.$t('manualAnswer.invitesTable.labels.status'),
      },
    ];

    if (!this.userProfile.permissions.manual.menu) {
      this.$router.push(`/dashboard/${this.userAuth.companyId}`);
    }

    if (this.userProfile.permissions.manual.submit) {
      this.fields.push({
        key: 'options',
        label: this.$t('manualAnswer.invitesTable.labels.manual'),
      });
    }

    this.updateTable(1);
  },

  watch: {
    myActionId: function watchMyActionId() {
      this.page = 1;
      this.updateTable();
    },

    myActionsIds: function watchMyActionId() {
      this.page = 1;
      this.updateTable();
    },

    calendarDates: function watchCalendarDates() {
      this.page = 1;
      this.updateTable();
    },

    myIh1: function watchMyMyIh1() {
      this.page = 1;
      this.updateTable();
    },

    myHierarchies1: function watchMyHierarchies1(){
      this.page = 1;
      this.updateTable();
    },

    myIh2: function watchMyMyIh2() {
      this.page = 1;
      this.updateTable();
    },

    myHierarchies2: function watchMyHierarchies2(){
      this.page = 1;
      this.updateTable();
    },

    myMetric: function watchMyMetric() {
      this.page = 1;
      this.updateTable();
    },

    actionGroupData: function watchActionGroup() {
      this.page = 1;
      this.updateTable();
    },

    'indicatorData.value': function watchIndicatorData() {
      this.page = 1;
      this.updateTable();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      this.page = 1;
      this.updateTable();
    },
  },

  methods: {
    ...mapActions('invites', [
      'setInvites',
      'setActionInfo',
      'updateDateRange',
      'updateToken',
    ]),
    ...mapActions('calendar', ['setDates']),

    checkName(anonymous, name) {
      if (anonymous === 'empty') {
        return 'Anônimo';
      } else if (this.userProfile.permissions.manual.anonymous_profile) {
        return 'Nome: ***************';
      } else if (name) {
        return name;
      }
      return 'Sem Nome';
    },

    checkUserData(value, profile) {
      if (value === 'empty') {
        return '-';
      } else if (profile) {
        return '************';
      } else if (value) {
        return value;
      }
      return '-';
    },

    handleFilter() {
      if (this.filter !== '' && this.filter !== null) {
        this.page = 1;
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(this.updateTable, 600);
      }

      if (this.filter === '') {
        this.filter = null;
        this.page = 1;
        this.updateTable();
      }
    },

    cleanFilter() {
      this.filter = null;
    },

    async updateTable() {
      this.loading = true;

      const response = await api.get(`invites/all/${this.userAuth.companyId}`, {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          startDate: this.calendarDates.start,
          endDate: this.calendarDates.end,
          page: this.page,
          limit: '10',
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myIh2 === '0' ? null : this.myIh2,
          metric: this.myMetric,
          filter: this.filter,
          groupId: this.actionGroupData._id,
          indicator: this.indicatorName,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
        },
      });

      this.myInvites.customers = response.data.customers;
      this.myInvites.paginate = Math.ceil(response.data.total / 10);

      this.loading = false;
    },

    refreshToken(id) {
      swal({
        title: this.$t('manualAnswer.messages.refresh.title'),
        text: this.$t('manualAnswer.messages.refresh.description'),
        icon: 'warning',
        buttons: [
          this.$t('manualAnswer.messages.refresh.cancelLabel'),
          this.$t('manualAnswer.messages.refresh.okLabel'),
        ],
        dangerMode: true,
      }).then(async (yes) => {
        if (yes) {
          this.loading = true;

          await this.updateToken({
            token: this.userAuth.token,
            companyId: this.userAuth.companyId,
            data: {
              inviteId: id,
            },
          });

          this.updateTable();
        }
      });
    },

    dateFormat(param) {
      const date = format(param, 'dd/MM/yyyy', { locale: pt });
      return date;
    },

    setDifferenceInDays(date) {
      const time = new Date() - date.getTime();
      const difference = (time / (1000 * 3600 * 24)).toFixed(0);

      return difference;
    },

    openModal(token, i) {
      // Zerando informações para coleta de perguntas adicionais
      this.$store.state.research.emotionControl = 0;
      this.$store.state.research.likeControl = 0;
      this.$store.state.research.reviewsControl = 0;
      this.$store.state.research.likertControl = 0;
      this.$store.state.research.csatControl = 0;
      this.$store.state.research.emotionReview = [];
      this.$store.state.research.likeReview = [];
      this.$store.state.research.reviewsReview = [];
      this.$store.state.research.likertReview = [];
      this.$store.state.research.csatReview = [];
      this.rowIndex = i;
      this.$store.state.invites.actionInfo = {};
      this.$store.state.invites.loadingModal = true;
      this.error = null;

      this.setActionInfo(token)
        .then(() => {
          this.loadingModal = false;

          this.actionInfo.additionalQuestions.forEach((el) => {
            if (el.type === 'MULTIPLE') {
              el.multipleValues = [];
            } else {
              el.review = undefined;
            }
          });
        })
        .catch(() => {
          this.loadingModal = false;
          this.error = this.$t('manualAnswer.noInvite');
        });
    },

    refresh() {
      this.setDates({
        start: null,
        end: null,
      });

      this.page = 1;
      this.updateTable();
    },

    getMetricLabel(metric) {
      if (metric === 'nps-0-10') {
        return this.$t('manualAnswer.nps010');
      } else if (metric === 'nps-1-5') {
        return this.$t('manualAnswer.nps15');
      } else if (metric === 'ces-1-5') {
        return this.$t('manualAnswer.ces15');
      } else if (metric === 'csat-1-5') {
        return this.$t('manualAnswer.csat15');
      } else if (metric === 'csat-1-5(media)') {
        return this.$t('manualAnswer.csatAverage15');
      }else if (metric === 'csat-0-10(media)') {
        return this.$t('manualAnswer.csat0to10Average');
      }
      return this.$t('manualAnswer.fiveStars');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.wrapper {
  padding: 8px;
}

.body {
  background-color: $white;
  padding: 16px;
  border-radius: 4px;
  border: 1px solid $gray-light;
}

.body h2 {
  text-transform: uppercase;
  font-size: 21px;
  font-weight: 100;
  color: $gray;
}

.header-icon {
  float: left;
  font-size: 12px;
  margin-top: 4px;
  padding-right: 12px;
  color: $gray;
}

.refresh-token {
  color: $primary;
  cursor: pointer;
  &:hover {
    color: green;
  }
}

.user-info {
  color: rgb(133, 131, 131);
}

.table-icons {
  color: $primary;
  font-size: 23px;
  max-width: 40px;
  overflow: hidden;

  svg {
    &:hover {
      color: #46b41e;
      cursor: pointer;
    }
  }
}

.pagination-area-manual-answers >>> a {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #4ce595;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
</style>

<style>
.pagination-area-manual-answers .active a {
  text-decoration: none;
  z-index: 1;
  color: #fff;
  background-color: #4ce595;
  border-color: #4ce595;
}

.pagination-area-manual-answers a {
  outline: none;
}

#manual-answer .modal-dialog {
    margin-top: 0 !important;
    margin-left: auto !important;
    margin-right: auto !important;
    top: 0 !important;
    bottom: 0 !important;
    left: 0 !important;
    right: 0 !important;
    height: 100vh !important;
    display: flex !important;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/manual/index.vue